<!--
 * @Author: yangxu yangxu@staff.hexun.com
 * @Date: 2025-02-18 14:48:58
 * @LastEditors: yangxu yangxu@staff.hexun.com
 * @LastEditTime: 2025-02-28 10:45:27
 * @FilePath: /js_celue-zuhe_src/src/components/Empty.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="empty-wrap">
    <div class="empty"></div>
  </div>
</template>
<style lang="scss">
.empty-wrap {
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: calc(var(--imgfontSize) * 140) 0; /* 70px -> calc(var(--imgfontSize) * 140) */

  .empty {
    width: calc(var(--imgfontSize) * 320); /* 160px -> calc(var(--imgfontSize) * 320) */
    height: calc(var(--imgfontSize) * 396); /* 198px -> calc(var(--imgfontSize) * 396) */
    background: url("../assets/img/empty.png") no-repeat center;
    background-size: 100%;
  }
}
</style>

